import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CashAdjustmentCreateDTO, CashAdjustmentState } from "../../../types/cash/cashAdjustment";

const initialFormState: CashAdjustmentCreateDTO = {

  sessionId: null,
  amount: 0,
  description: "",
  adjustmentType: "INCREASE"

};

const initialState: CashAdjustmentState = {

  form: initialFormState,
  loading: false,
  showModal: false

};

const cashAdjustmentSlice = createSlice({

  name: "cashAdjustment",

  initialState,

  reducers: {

    setCashAdjustmentForm(state, action: PayloadAction<CashAdjustmentCreateDTO>) {

      state.form = action.payload;

    },

    updateCashAdjustmentField(
      state,
      action: PayloadAction<{ field: keyof CashAdjustmentCreateDTO; value: any }>
    ) {

      const { field, value } = action.payload;

      state.form = {
        ...state.form,
        [field]: value
      };

    },

    clearCashAdjustmentForm(state) {

      state.form = initialFormState;

    },

    setLoading(state, action: PayloadAction<boolean>) {

      state.loading = action.payload;

    },

    openModal(state) {

      state.showModal = true;

    },

    closeModal(state) {

      state.showModal = false;

    }

  }

});

export const {

  setCashAdjustmentForm,
  updateCashAdjustmentField,
  clearCashAdjustmentForm,

  setLoading,

  openModal,
  closeModal

} = cashAdjustmentSlice.actions;

export default cashAdjustmentSlice.reducer;